import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CONTACT_INFO } from '../../constants';
import { fetchSettings } from '../../services/api';
import type { PromoBanner, ContactInfo } from '../../types';
import './TopBar.css';

/**
 * Top contact bar component
 * Quick access to phone, SMS, and email
 * Promo banner and contact info fetched from backend settings
 */
const TopBar: React.FC = () => {
	const { t } = useTranslation();
	const [promoBanner, setPromoBanner] = useState<PromoBanner>({
		enabled: true,
		text: 'Book Today & Get $30 OFF!',
		emoji: '🔥',
	});
	const [contactInfo, setContactInfo] = useState<ContactInfo>({
		phone: CONTACT_INFO.phone,
		email: CONTACT_INFO.email,
		contactPerson: 'Family Friends Hibachi Team',
	});

	useEffect(() => {
		const loadSettings = async () => {
			try {
				const response = await fetchSettings();
				if (response.success && response.settings) {
					if (response.settings.promoBanner) {
						setPromoBanner(response.settings.promoBanner);
					}
					if (response.settings.contactInfo) {
						setContactInfo(response.settings.contactInfo);
					}
				}
			} catch (error) {
				// Use defaults
			}
		};
		loadSettings();
	}, []);

	return (
		<div className="top-bar">
			<div className="top-bar-container">
				<div className="top-bar-left">
					{promoBanner.enabled && (
						<span className="top-bar-promo">
							{promoBanner.emoji} {promoBanner.text}
						</span>
					)}
				</div>
				<div className="top-bar-right">
					<a href={`tel:${contactInfo.phone}`} className="top-bar-link">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
							<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
						</svg>
						<span>{contactInfo.phone}</span>
					</a>
					<a href={`sms:${contactInfo.phone}`} className="top-bar-link">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
							<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
						</svg>
						<span>{t('topBar.textUs', 'Text Us')}</span>
					</a>
					<a href={`mailto:${contactInfo.email}`} className="top-bar-link">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
							<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
							<polyline points="22,6 12,13 2,6"/>
						</svg>
						<span>{t('topBar.email', 'Email')}</span>
					</a>
				</div>
			</div>
		</div>
	);
};

export default TopBar;


